const PRE_ACTIVE_STATUS = {
    REJECTED: "مرفوض",
    PENDING: "بانتظار الموافقة",
    APPROVED: "تم التأكيد",
}

export default PRE_ACTIVE_STATUS;